module.exports = __webpack_public_path__ + "img/camera-icon.bffd1917.svg";